import React from 'react';
import { IMaskInput } from 'react-imask';

export default class NumberInput extends React.Component {

    state={
        scale:2
    }

    componentDidMount(){
        if(this.props.scale != undefined)
        {
            this.setState({scale: this.props.scale});
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.scale != this.props.scale)
        {
            this.setState({scale: this.props.scale});
        }
    }

    handleFocus = (event) => {
        event.target.select();
        if(this.props.onFocus !== undefined){
            this.props.onFocus(event);
        }
    }

    render() {
        const type = this.props.type;
        let disabled = false;
        if (this.props.disabled !== undefined) {
            disabled = this.props.disabled;
        }
        let negative = false;
        if (this.props.negative !== undefined) {
            negative = this.props.negative;
        }
        switch (type) {
            default:
            case "Integer": {
                const className = this.props.className + " input-number";
                return (<IMaskInput
                    id={this.props.id}
                    mask={Number}
                    className={className}
                    radix="."
                    scale={0}
                    signed={negative}
                    value={this.props.value}
                    unmask={'typed'} // true|false|'typed'
                    // DO NOT USE onChange TO HANDLE CHANGES!
                    // USE onAccept INSTEAD
                    onBlur={
                        (typedValue, mask) => {
                          if(this.props.onBlur !== undefined){
                            this.props.onBlur()
                          } 
                        }
                      }
                    onFocus={this.handleFocus}
                    autoFocus={this.props.autoFocus != null ? this.props.autoFocus : false}
                    onKeyPress={this.props.onKeyPress != null ? (e) => this.props.onKeyPress(e) : () => {}}
                    onAccept={
                        // depending on prop above first argument is
                        // `value` if `unmask=false`,
                        // `unmaskedValue` if `unmask=true`,
                        // `typedValue` if `unmask='typed'`
                        (typedValue, mask) => {
                            var event = {
                                target: {},
                            };
                            var input = mask.el.input;
                            event.target.id = input.id;
                            event.target.name = input.name;
                            event.target.value = typedValue;
                            if (this.props.onChange !== undefined) {
                                this.props.onChange(event);
                            }
                        }
                    }
                    // ...and more mask props in a guide

                    // input props also available
                    placeholder={this.props.placeholder}
                    disabled={disabled}
                    min={this.props.min}
                    max={this.props.max}
                />);
            }
            case "Rate": {
                const className = this.props.className + " input-number";
                let defaultScale = 4;
                if (this.props.scale !== undefined) {
                    defaultScale = this.props.scale
                }
                let padFractional = true;
                if (defaultScale === 0) {
                    padFractional = false;
                }
                return (<IMaskInput
                    id={this.props.id}
                    mask={Number}
                    className={className}
                    radix="."
                    signed={negative}
                    mapToRadix={[","]}
                    scale={defaultScale}
                    padFractionalZeros={padFractional}
                    value={this.props.value}
                    unmask={'typed'} // true|false|'typed'
                    // DO NOT USE onChange TO HANDLE CHANGES!
                    // USE onAccept INSTEAD
                    onFocus={this.handleFocus}
                    onBlur={
                        (typedValue, mask) => {
                          if(this.props.onBlur !== undefined){
                            this.props.onBlur()
                          } 
                        }
                      }
                    onAccept={
                        // depending on prop above first argument is
                        // `value` if `unmask=false`,
                        // `unmaskedValue` if `unmask=true`,
                        // `typedValue` if `unmask='typed'`
                        (typedValue, mask) => {
                            var event = {
                                target: {},
                            };
                            var input = mask.el.input;
                            event.target.id = input.id;
                            event.target.name = input.name;
                            event.target.value = typedValue;
                            if (this.props.onChange !== undefined) {
                                this.props.onChange(event);
                            }
                        }
                    }
                    // ...and more mask props in a guide

                    // input props also available
                    placeholder={this.props.placeholder}
                    disabled={disabled}
                />);
            }
            case "Currency": {
                const className = this.props.className + " input-number";
                let defaultScale = 2;
                if (this.state.scale !== undefined) {
                    defaultScale = this.state.scale
                }
                let padFractional = true;
                if (defaultScale === 0) {
                    padFractional = false;
                }

                return (<IMaskInput
                    id={this.props.id}
                    mask={Number}
                    className={className}
                    radix="."
                    thousandsSeparator=","
                    scale={defaultScale}
                    signed={negative}
                    padFractionalZeros={padFractional}
                    value={this.props.value}
                    unmask={'typed'} // true|false|'typed'
                    // DO NOT USE onChange TO HANDLE CHANGES!
                    // USE onAccept INSTEAD
                    onBlur={
                        (typedValue, mask) => {
                          if(this.props.onBlur !== undefined){
                            this.props.onBlur()
                          } 
                        }
                      }
                    onFocus={this.handleFocus}
                    onAccept={
                        // depending on prop above first argument is
                        // `value` if `unmask=false`,
                        // `unmaskedValue` if `unmask=true`,
                        // `typedValue` if `unmask='typed'`
                        (typedValue, mask) => {
                            var event = {
                                target: {},
                            };
                            var input = mask.el.input;
                            event.target.id = input.id;
                            event.target.name = input.name;
                            event.target.value = typedValue;
                            if (this.props.onChange !== undefined) {
                                this.props.onChange(event);
                            }
                        }
                    }
                    // ...and more mask props in a guide

                    // input props also available
                    placeholder={this.props.placeholder}
                    disabled={disabled}
                />);
            }
        }
    }
}